import { Component, OnInit, ElementRef, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { UserService } from '@teem/services/user.service';
import { LoaderService } from '@teem/services/loader.service';
import { AuthService } from '@teem/app/core/services/auth.service';
import { uniqueEmailValidator, uniquePhoneValidator } from '@teem/app/core/utils/email-unique.validator';
import { messages as i18n } from '@teem/constants/messages';

declare var $: any;

@Component({
	selector: 'add-store-type-modal',
	styleUrls: ['./add-store-type-modal.scss'],
	templateUrl: './add-store-type-modal.component.html'
})
export class AddStoreTypeModalComponent implements OnInit, AfterViewInit {
	submitted: boolean = false;
	addStoreTypeForm: FormGroup;
	companyTypes : any = ["Bakery / Dessert", "Blogging", "Bookkeeping / Accounting", "Business Consulting", "Calligraphy", "Catering", "Coaching", "Dj / Entertainment", "Fashion / Accessories", "Floral Design", "Food & Drinks", "Graphic Design", "Hair & Makeup", "Health & Wellness", "Interior Design", "Maker / Artisan", "Marketing / PR", "Management", "Photography", "Event Planning", "Rentals / Photo booths", "Stationary", "Videography", "Visual Art", "Web Design", "Transportation", "Contracting", "IT Services", "Others"];
	businessTypes : any;

	servicesFeatures = [
		{ displayName: 'Invoicing', value: 'invoicing' },
		{ displayName: 'Online Store', value: 'online_store' },
		{ displayName: 'Invoicing and Online Store', value: 'invoicing_online_store' }
	  ];
	  
	productsFeatures = [
		{ displayName: 'Invoicing', value: 'invoicing'},
		{ displayName: 'Online Store', value: 'online_store' },
		{ displayName: 'Food & Beverage Ordering', value: 'food_beverage_ordering' },
		{ displayName: 'Invoicing and Online Store', value: 'invoicing_online_store' }
	];

	@Input() userInfo;

	constructor(
		private fb: FormBuilder,
		public activeModal: NgbActiveModal,
		private userService: UserService,
		private loaderService: LoaderService,
		private authService: AuthService,
		private el: ElementRef

	) {
		this.createAddStoreTypeFormGroup();
	}

	ngOnInit(): void {
		let storeType = this.addStoreTypeForm.get('store_type')?.value;
		if (storeType == 'product') {
			this.businessTypes = this.productsFeatures;
		} else {
			this.businessTypes = this.servicesFeatures;
		}

		this.addStoreTypeForm.get('store_type').setValue(this.userInfo?.store_type);
		this.addStoreTypeForm.get('business_type').setValue(this.userInfo?.business_type);
		this.addStoreTypeForm.get('company_type').setValue(this.userInfo?.company_type);
		this.addStoreTypeForm.get('business_name').setValue(this.userInfo?.business_name);
		this.addStoreTypeForm.get('phone').setValue(this.userInfo?.phone);
	}

  	ngAfterViewInit() {
		setTimeout(function () {
			$('select[nice-select]').niceSelect('update')
		}, 500)
	}


	createAddStoreTypeFormGroup() {
		this.addStoreTypeForm = this.fb.group({
			store_type: ['product', Validators.required],
			business_type:  ['', Validators.required],
			company_type:  ['', Validators.required],
			business_name:  ['', Validators.required],
			// phone: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
			phone: ['', [Validators.required, Validators.pattern(/^\d{8,10}$/)], [uniquePhoneValidator(this.authService)] ],
			profession:  ['', Validators.required],
			size_of_team:  ['', Validators.required],
		});
	}

	get f() {
		return this.addStoreTypeForm.controls;
	}

	changeStoreType() {
		let storeType = this.addStoreTypeForm.get('store_type')?.value;
		if (storeType == 'product') {
			this.businessTypes = this.productsFeatures;
		} else {
			this.businessTypes = this.servicesFeatures;
		}
		this.addStoreTypeForm.get('business_type').setValue('invoicing');
		setTimeout(function () {
			$('select[nice-select]').niceSelect('update')
		}, 500)
	}

	onSubmit() {
		this.submitted = true;
		if (this.addStoreTypeForm.valid) {

			let fd = this.addStoreTypeForm.value;
			this.loaderService.startLoading();

			this.userService.updateStoreType(fd)
				.subscribe(
					(res: any) => {
						this.loaderService.stopLoading();

						this.addStoreTypeForm.reset();
						this.activeModal.close(res);

						Swal.fire(i18n.done, i18n.dashboard.store_type_update_successfully, 'success');
					},
					(err) => {
						this.loaderService.stopLoading();
						if (err.status === 422) {
							if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
								let validationErrors = err.error.errors;
								Object.keys(validationErrors).forEach((prop) => {
									this.addStoreTypeForm.get(prop)?.setErrors({
										serverError: validationErrors[prop]
									})
								})
							}
						}

						Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
					}
				)
			this.submitted = false;
		}
	}
}
